// extracted by mini-css-extract-plugin
module.exports = {"table":"guest-policy_table__zC4J_"};